import { initializeApp } from 'firebase/app'
import {
  getFirestore,
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  orderBy,
  query,
} from 'firebase/firestore'
import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyAVBTZ9wqcNagiOr3mzyFzsxe1Oai2kwJs',
  authDomain: 'lumi-crafts.firebaseapp.com',
  projectId: 'lumi-crafts',
  storageBucket: 'lumi-crafts.firebasestorage.app',
  messagingSenderId: '632364953733',
  appId: '1:632364953733:web:e7a047a51469f35752f9ec',
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
export const auth = getAuth(app)

// Auth
export const login = (email, password) =>
  signInWithEmailAndPassword(auth, email, password)

export const logout = () => signOut(auth)

export const onAuthChange = (callback) =>
  onAuthStateChanged(auth, callback)

// Firestore
const COL = 'productos'

export async function getProductos() {
  const q = query(collection(db, COL), orderBy('orden', 'asc'))
  const snap = await getDocs(q)
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
}

export async function addProducto(data) {
  const ref = await addDoc(collection(db, COL), {
    name: data.name,
    image: data.image || '',
    price: data.price || '',
    inStock: data.inStock !== false,
    orden: Date.now(),
  })
  return ref.id
}

export async function updateProducto(id, data) {
  await updateDoc(doc(db, COL, id), {
    name: data.name,
    image: data.image || '',
    price: data.price || '',
    inStock: data.inStock !== false,
  })
}

export async function deleteProducto(id) {
  await deleteDoc(doc(db, COL, id))
}

export async function reorderProductos(products) {
  const promises = products.map((p, i) =>
    updateDoc(doc(db, COL, p.id), { orden: i })
  )
  await Promise.all(promises)
}
